<div class="legal-page">
  <div class="legal-header">
    <h2>Privacy Policy</h2>
  </div>

  <div class="legal-content">
    <p><strong>Last Updated:</strong> March 27, 2026</p>

    <h4>1. Introduction</h4>
    <p>
      This Privacy Policy describes how Livepass, operated by MultiTV Solution, collects, uses, and protects your
      personal information when you access or use the Platform.
    </p>

    <h4>2. Information We Collect</h4>
    <p>We may collect the following categories of information:</p>

    <h5>a. Personal Information</h5>
    <p>Including but not limited to:</p>
    <ul>
      <li>name</li>
      <li>email address</li>
      <li>phone number</li>
      <li>billing information</li>
    </ul>

    <h5>b. Usage Data</h5>
    <ul>
      <li>device information</li>
      <li>browser type</li>
      <li>IP address</li>
      <li>interaction with Platform</li>
    </ul>

    <h5>c. Transaction Data</h5>
    <ul>
      <li>bookings</li>
      <li>payment confirmations</li>
      <li>purchase history</li>
    </ul>

    <h4>3. Use of Information</h4>
    <p>We use the collected information to:</p>
    <ul>
      <li>provide and improve Services</li>
      <li>process transactions</li>
      <li>communicate with Users</li>
      <li>personalize recommendations</li>
      <li>prevent fraud and ensure security</li>
    </ul>

    <h4>4. Sharing of Information</h4>
    <p>We may share your information with:</p>
    <ul>
      <li>Organizers for event execution and communication</li>
      <li>Payment service providers</li>
      <li>Third-party vendors assisting in operations</li>
    </ul>
    <p>We do not sell your personal data to third parties.</p>

    <h4>5. Data Security</h4>
    <p>
      We implement reasonable technical and organizational measures to safeguard your information. However, no
      transmission over the internet is completely secure.
    </p>

    <h4>6. Data Retention</h4>
    <p>Your data is retained:</p>
    <ul>
      <li>as long as necessary for providing Services</li>
      <li>as required by applicable laws</li>
    </ul>

    <h4>7. User Rights</h4>
    <p>You may:</p>
    <ul>
      <li>access and update your information</li>
      <li>request deletion of your data</li>
      <li>opt out of promotional communications</li>
    </ul>

    <h4>8. Cookies</h4>
    <p>We use cookies and similar technologies to:</p>
    <ul>
      <li>enhance user experience</li>
      <li>analyze usage patterns</li>
    </ul>
    <p>You may control cookie preferences through your browser settings.</p>

    <h4>9. Third-Party Links</h4>
    <p>
      The Platform may contain links to third-party services. We are not responsible for their privacy practices.
    </p>

    <h4>10. Children's Privacy</h4>
    <p>The Platform is not intended for individuals under 18 without parental supervision.</p>

    <h4>11. Updates to Policy</h4>
    <p>
      We may revise this Privacy Policy from time to time. Continued use of the Platform constitutes acceptance.
    </p>

    <h4>12. Contact</h4>
    <p>For any privacy-related queries:</p>
    <p><strong>Email:</strong> yash.kumar@multitvsolution.com</p>
    <p><strong>Company:</strong> MultiTV Solution</p>
  </div>
</div>

